/* Qwitech storefront entrance animation — vanilla JS, no dependencies.
   Runs once on load. If any element is missing, it silently does nothing,
   so the storefront renders exactly as before. No sound, no video. */
(function () {
  function init() {
    var main = document.querySelector('main#MainContent') || document.querySelector('main');
    if (!main) return;

    function findTextElement(root, needle) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf(needle) !== -1) {
          return node.parentElement;
        }
      }
      return null;
    }

    /* --- Header logo: gentle fade/scale on load --- */
    var logoImg = document.querySelector('img[alt*="Qwitech"], img[alt*="QWITECH"]');
    if (logoImg) logoImg.classList.add('qwitech-logo-enter');

    /* --- Hero: letter-by-letter QWITECH wordmark above the headline --- */
    var headlineEl = findTextElement(main, 'Everything you need. One store.');
    if (headlineEl) {
      var heroSection = headlineEl.closest('section') || headlineEl.closest('[class*="hero"]') || headlineEl.parentElement;
      if (heroSection) heroSection.classList.add('qwitech-hero');

      var wordmark = document.createElement('div');
      wordmark.className = 'qwitech-wordmark';
      wordmark.setAttribute('aria-hidden', 'true');
      /* Logo color rule (master, 2026-11-01): QW white, ITECH blue. */
      'QWITECH'.split('').forEach(function (ch, i) {
        var span = document.createElement('span');
        span.className = 'qw-letter' + (i >= 2 ? ' qw-letter--blue' : '');
        span.style.setProperty('--i', i);
        span.textContent = ch;
        wordmark.appendChild(span);
      });
      headlineEl.parentNode.insertBefore(wordmark, headlineEl);

      /* Hero entrance: headline, subline, button follow the wordmark. */
      var enterEls = [headlineEl];
      var scope = heroSection || headlineEl.parentElement;
      var paras = scope.querySelectorAll('p');
      if (paras.length) enterEls.push(paras[0]);
      var cta = scope.querySelector('a.button, button.button, a[href*="/collections"]');
      if (cta && enterEls.indexOf(cta) === -1) enterEls.push(cta);
      var delays = [0.95, 1.1, 1.25];
      enterEls.forEach(function (el, i) {
        el.classList.add('qwitech-hero-enter');
        el.style.animationDelay = delays[Math.min(i, delays.length - 1)] + 's';
      });
    }

    /* --- Department tiles: tag the section for hover lift --- */
    var deptText = findTextElement(main, 'Shop by department');
    if (deptText) {
      var deptSection = deptText.closest('section') || deptText.parentElement;
      if (deptSection) deptSection.classList.add('qwitech-departments');
    }

    /* --- Scroll fade-up for sections below the hero --- */
    var sections = main.querySelectorAll('section');
    var revealSections = [];
    sections.forEach(function (section) {
      if (section.classList.contains('qwitech-hero')) return;
      section.classList.add('qwitech-reveal');
      revealSections.push(section);
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealSections.forEach(function (section) {
        observer.observe(section);
      });
    } else {
      revealSections.forEach(function (section) {
        section.classList.add('in-view');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
